<template>
    <form-container :header="translate('userIdentity.identityInformation')" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col col-limit">
                <div class="form-group">
                    <label>{{translate('approvalAuthorityEditor.name')}}</label>
                    <input @input="checkInput('FirstName',$event)" v-model="data.FirstName" type="text" class="form-control" maxlength="50" required />
                </div>
                <div class="form-group">
                    <label>{{translate('approvalAuthorityEditor.surname')}}</label>
                    <input @input="checkInput('LastName',$event)" v-model="data.LastName" type="text" class="form-control" maxlength="50" required />
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>{{translate('userIdentity.identityType')}}</label>
                            <select v-model="data.Origin" required class="form-control">
                                <option value="TC">{{translate('userIdentity.tcIdentity')}}</option>
                                <option value="Passport">{{translate('userIdentity.passport')}}</option>
                                <option value="YTCKN">{{translate('userIdentity.foreignId')}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group" v-if="data.Origin == 'TC'">
                            <label>{{translate('approvalAuthorityEditor.identityNumber')}}</label>
                            <input v-model="data.IdentityNumber" @input="checkInput('IdentityNumber',$event)" type="tel" class="form-control" maxlength="11" :required="isIdentityNumberRequired" />
                        </div>
                        <div class="form-group" v-if="data.Origin == 'Passport'">
                            <label>{{translate('userIdentity.passportNo')}}</label>
                            <input v-model="data.IdentityNumber" @input="checkInput('IdentityNumber',$event)" type="text" class="form-control" maxlength="50" :required="isIdentityNumberRequired" />
                            <div class="form-help">
                                {{translate('userIdentity.passportNoText')}}
                            </div>
                        </div>
                        <div class="form-group" v-if="data.Origin == 'YTCKN'">
                            <label>{{translate('userIdentity.foreignIdNo')}}</label>
                            <input v-model="data.IdentityNumber" @input="checkInput('IdentityNumber',$event)" type="tel" class="form-control" maxlength="11" :required="isIdentityNumberRequired" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="row" v-if="data.Origin == 'YTCKN'"> 
                            <div class="col-12">                         
                                <label>{{translate('userIdentity.birthDate')}}</label>
                            </div>  
                            <div class="col-4">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{translate('userIdentity.year')}}</span>
                                    </div>
                                    <input v-model="data.BirthYear" type="number" class="form-control" min="1900" :max="new Date().getFullYear()" :required="isBirthYearRequired"  :aria-label="translate('userIdentity.birthYear')">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{translate('userIdentity.month')}}</span>
                                    </div>
                                    <input v-model="data.BirthMonth" type="number" class="form-control" min="1" max="12" :required="isBirthYearRequired"  :aria-label="translate('userIdentity.birthMonth')">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{translate('userIdentity.day')}}</span>
                                    </div>
                                    <input v-model="data.BirthDay" type="number" class="form-control" min="1" max="31" :required="isBirthYearRequired"  :aria-label="translate('userIdentity.birthDay')">
                                </div>
                            </div>

                        </div>

                        <div class="form-group" v-else>
                            <label>{{translate('userIdentity.birthYear')}}</label>
                            <!-- <date-input v-model="data.BirthDate" :isBirthDate="true" class="form-control" required></date-input> -->
                            <input v-model="data.BirthYear" type="number" class="form-control" min="1900" :max="new Date().getFullYear()" :required="isBirthYearRequired" />
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>{{translate('userIdentity.mobilePhone')}}</label>
                    <input v-model="data.Mobile" @input="checkInput('Mobile',$event)" type="tel" class="form-control" maxlength="10" placeholder="5XXXXXXXXX" :required="isMobileRequired" />
                </div>

                <div class="form-group">
                    <label>{{translate('user.mobileSignOperator')}}</label>
                    <select v-model="data.MobileSignOperator" class="form-control">
                        <option value="">{{translate('user.dontHaveMobileSign')}}</option>
                        <option value="TURKCELL">Turkcell</option>
                        <option value="AVEA">Türk Telekom</option>
                        <option value="VODAFONE">Vodafone</option>
                    </select>                    
                </div>

                <div class="form-group">
                    <label>{{translate('user.mobileSignNumber')}}</label>
                    <input class="form-control" id="MobileSignNumber"  @input="checkInput('MobileSignNumber',$event)" :disabled="!data.MobileSignOperator" required v-model="data.MobileSignNumber" placeholder="5XXXXXXXXX" type="tel" maxlength="10">
                </div>

                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="KVKK" v-model="data.KVKK" ref="kvkkCheckbox">
                    <label class="form-check-label" for="KVKK">
                        <span v-if="getKVKKUrl" @click="isKvkkModalVisible = true" class="text-primary">{{ translate('userIdentity.kvkkText') }}</span><span v-else>{{ translate('userIdentity.kvkkText') }}</span>{{translate('userIdentity.kvkkText2')}}                      
                    </label>
                </div>
            </div>
            <div class="col col-4">
                <label for="">&nbsp;</label>
                <div v-if="isIdentityNumberRequired" class="alert alert-warning">
                    {{translate('userIdentity.identityNumberRequiredText')}}
                    <p v-if="this.hasAuth('Signer')" class="mt-3">
                    {{translate('userIdentity.signerIdentityNumberRequired')}}
                    </p>
                </div>
                <div v-else class="alert alert-info">
                    <span v-html="translate('userIdentity.identityOptional')"></span>
                </div>             
                <div v-if="verifyIdentityDataFromGovService" class="alert alert-info">
                    {{translate('userIdentity.identityWarning')}}
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col"> 
                    <div class="row">
                        <div class="col">
                            <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                        </div>
                        <div class="col text-right">
                            <button type="submit" accesskey="k" class="btn btn-success">{{translate('save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div v-if="isKvkkModalVisible" class="modal fade show" style="display: block; " tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ translate('userIdentity.kvkkHeader') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="closeKvkkModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <PDFViewer :pdfUrl="getKVKKUrl" :controllerVisible="false"></PDFViewer>
                    </div>
                    <div class="modal-footer footer-button-container-1">
                        <button type="button" class="btn btn-outline-secondary" @click="closeKvkkModal">{{translate('close')}}</button>
                        <div>
                            <input type="checkbox" class="form-check-input" id="KvkkModal" v-model="kvkkFromModal">
                            <label class="form-check-label" for="KvkkModal">
                                <p><span class="text-primary">{{ translate('userIdentity.kvkkText') }}</span> {{translate('userIdentity.kvkkText2')}}</p>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form-container>
</template>

<script>
import axios from 'axios';
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
// import dateInput from '../components/DateInput.vue'
import PDFViewer from '../components/PDFComponent/PDFViewer.vue';
export default {
    mixins: [formMixin],
    components: {
    formContainer,
    // dateInput,
    PDFViewer
},
    
    created(){
        this.getData(this.$route.params.id, true, this.$route.query.kind);
    },
    computed: {
        getKVKKUrl()
        {
            if(this.isOnPrem)
                return window.settings.customization?.KVKKUrl;
            else
                return "https://www.izometri.com.tr/Content/kvkk/izonay-kvkk.pdf";
        },
        isIdentityNumberRequiredForInternalUser()
        {
            return this.$root.$data.login.Account.Params.IsIdentityNumberRequiredForInternalUser;
        },
        verifyIdentityDataFromGovService()
        {
            return this.$root.$data.login.Account.Params.VerifyIdentityDataFromGovService
        },
        isIdentityNumberRequired(){
            return this.isIdentityNumberRequiredForInternalUser || this.hasAuth("Signer");
        },
        isBirthYearRequired(){
            return this.verifyIdentityDataFromGovService && this.isIdentityNumberRequired;
        },
        isMobileRequired(){
            return this.$root.$data.login.Account.Params.IsMultiFactorAuthEnabled;
        }
    },
    data() {
        return {
            loading: false,
            modelName: 'UserIdentity',
            data: {},
            isKvkkModalVisible: false,
            kvkkModalOpened: false,
            kvkkFromModal: false,
        }
    },
    watch: {
        'data.KVKK': function(oldVal){
            if(oldVal && !this.kvkkModalOpened){
                if(this.getKVKKUrl){
                    this.openKvkkModal()
                    this.$refs.kvkkCheckbox.checked = false;
                }else {
                    this.$refs.kvkkCheckbox.checked = true;
                    this.data.KVKK = true;
                }
                

            }
        }
    },
    methods: {
        openKvkkModal(){
            this.$refs.kvkkCheckbox.checked = false;
            this.data.KVKK = false
            this.isKvkkModalVisible = true;
            this.kvkkModalOpened = true;
        },
        closeKvkkModal(){
            if(this.kvkkFromModal == true){
                this.data.KVKK = true
            }else{
                this.kvkkModalOpened = false;
                this.$refs.kvkkCheckbox.checked = false;
                this.data.KVKK = false;
            }
            this.isKvkkModalVisible = false;
            console.log(this.data.KVKK, this.kvkkFromModal)
        },
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        save(){
            this.loading = true;
            this.errorMessage = null;
            var comp = this;

            if(!this.data.KVKK)
            {
                alert(this.translate('warnings.kvkkMustBeAccepted'));
                this.loading = false;
                return;
            }

            return axios
              .post(`/${this.modelName}/post/${this.data.Id}`, this.data)
              .then(x => {
                axios.post('/token/refresh')
                .then(x => {
                    window.localStorage.setItem('user', JSON.stringify(x.data.Data));
                    axios.defaults.headers.common['token'] = x.data.Data.Key;
                    comp.$root.$data.login = x.data.Data;
                    comp.$router.go(-1);
                });

                return x;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        },
        goBack(){
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>

.footer-button-container-1{
    display: flex;
    align-items: center;
    justify-content: space-between !important;
}
</style>